import bg from "../assets/images/Home/hero_bg.jpg";

const HeroSlider = () => {
  return (
    <section className="slider-area home_hero_section">
      <img src={bg} alt="Hero" className="desktop_image" />
    </section>
  );
};

export default HeroSlider;
